/** Session flag: show one-time welcome dialog after login (per browser tab session until dismissed). */
export const WELCOME_GREETING_STORAGE_KEY = 'aerta_welcome_greeting_dismissed';

export function clearWelcomeGreetingFlag() {
  try {
    sessionStorage.removeItem(WELCOME_GREETING_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
